/**
 * This store must have all global league data, like all league games per season,
 * all league plays by season, all league teams per season, all league players by season, etc.
 */
export default {};
